import React from "react";
import PageComponent from "js/components/pages/PageComponent";
import AppUser from "js/stores/AppUser";
import AppContent from "js/components/AppContent";
import Constraint from "js/components/Constraint";
import {Link} from "@reach/router";
import {navigate,url} from "js/services/Network";
import {Button} from "reactstrap";


export default class SPPOnboardSuccess extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      success: true
    }
  }
  pageName = 'SPPOnboardSuccess';
  pageEvent = () => {
    if (AppUser.isLoggedIn){

    }
  }
  renderPage() {

    return (
      <AppContent className="seller-link-page" padded>
        <div className="pod-container">
          <div className="tw-flex tw-justify-center tw-pt-32 tw-px-6">
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-max-w-xl tw-gap-6">
              <h5 className="tw-text-center tw-font-semibold tw-text-2xl tw-text-primary">
                Success
              </h5>
              <img
                src="/images/ssp/success.png"
                alt="success-img"
                className="tw-w-[74px] tw-h-[74px]"
              />
              <p className="tw-text-center tw-text-[#2C353CB2]">
                We have received your form. Pease look out for a mail from us. We
                will reach out to you soon. PPP is dependent on sales volume. Sell
                more to qualify.
              </p>
              <button className="btn btn-pod tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-6 tw-text-white"
                onClick={() => navigate(url('create-payment-link-page', { step: null },''))}>
                <img
                  src="/images/icons/grid.svg"
                  alt="shop"
                  className="size-24px"
                />&nbsp;&nbsp;
                Create an item
              </button>
            </div>
          </div>
        </div>
      </AppContent>
    )
  }

}
